//   ['NEW_PROJECT', NEW_PROJECT, :core, :project],   ['UPDATE_PROJECT',
// UPDATE_PROJECT, :core, :project],   ['NEW_PROJECT_MEMBER',
// NEW_PROJECT_MEMBER, :core, :project],   ['UPDATE_PROJECT_MEMBER',
// UPDATE_PROJECT_MEMBER, :core, :project],   ['DELETE_PROJECT_MEMBER',
// DELETE_PROJECT_MEMBER, :core, :project],   ['NEW_WBS_ITEM', NEW_WBS_ITEM,
// 'New WBS Item', :project],   ['UPDATE_WBS_ITEM', UPDATE_WBS_ITEM, 'Update WBS
// Item', :project],   ['DELETE_WBS_ITEM', DELETE_WBS_ITEM, 'Delete WBS Item',
// :project],   ['NEW_MEMO', NEW_MEMO, :project],   ['UPDATE_MEMO', UPDATE_MEMO,
// :project],   ['RESPOND_TO_RFI', RESPOND_TO_RFI, 'Respond to RFI', :project],
//  ['WBS_IMPORT', WBS_IMPORT, 'WBS Import', :project],   ['NEW_ACTION',
// NEW_ACTION, :project], # was NEW_DEFECT,   ['UPDATE_ACTION', UPDATE_ACTION,
// :project], # was UPDATE_DEFECT,   ['DELETE_ACTION', DELETE_ACTION, :project],
// # was DELETE_DEFECT,   ['DELETE_MEMO', DELETE_MEMO, :project],
// ['NEW_REPORT', NEW_REPORT, 'New Punch List', :project],   ['UPDATE_REPORT',
// UPDATE_REPORT, 'Update Punch List', :project],   ['DELETE_REPORT',
// DELETE_REPORT, 'Delete Punch List', :project],   ['SEND_REPORT', SEND_REPORT,
// 'Send Punch List', :project],   ['SEND_MEMO', SEND_MEMO, :project],
// ['NEW_DRAWING', NEW_DRAWING, :project],   ['UPDATE_DRAWING', UPDATE_DRAWING,
// :project],   ['DELETE_DRAWING', DELETE_DRAWING, :project],   ['NEW_FORM',
// NEW_FORM, :project],   ['UPDATE_FORM', UPDATE_FORM, :project],
// ['DELETE_FORM', DELETE_FORM, :project],   ['SEND_FORM', SEND_FORM, :project],
//   ['NEW_PROJECT_LIST', NEW_PROJECT_LIST, :project],   ['UPDATE_PROJECT_LIST',
// UPDATE_PROJECT_LIST, :project],   ['DELETE_PROJECT_LIST',
// DELETE_PROJECT_LIST, :project],   ['NEW_DRAWING_ANNOTATION',
// NEW_DRAWING_ANNOTATION, :project],   ['UPDATE_DRAWING_ANNOTATION',
// UPDATE_DRAWING_ANNOTATION, :project],   ['DELETE_DRAWING_ANNOTATION',
// DELETE_DRAWING_ANNOTATION, :project],   ['IMPORT_DRAWINGS', IMPORT_DRAWINGS,
// :project],   ['NEW_USER_DRAWING_EVENT', NEW_USER_DRAWING_EVENT, :project],
// ['REPORT_GENERATED', REPORT_GENERATED, 'Punch List Generated', :project],
// ['CREATE_PROJECT_USER_PROFILE', CREATE_PROJECT_USER_PROFILE, :project],
// ['UPDATE_PROJECT_USER_PROFILE', UPDATE_PROJECT_USER_PROFILE, :project],
// ['DELETE_PROJECT_USER_PROFILE', DELETE_PROJECT_USER_PROFILE, :project],
// ['SEND_ACTION', SEND_ACTION, :project],

import {
  SUBTYPE_NEW,
  SUBTYPE_CREATE,
  SUBTYPE_UPDATE,
  SUBTYPE_SEND,
  SUBTYPE_DELETE,
  SUBTYPE_DRAWING,
  SUBTYPE_UNKNOWN,
} from '../consts/consts';

export default function getTransactionSubtype(subtype) {
  const typeArray = [
    SUBTYPE_DRAWING,
    SUBTYPE_NEW,
    SUBTYPE_CREATE,
    SUBTYPE_UPDATE,
    SUBTYPE_SEND,
    SUBTYPE_DELETE,
  ];

  let result = SUBTYPE_UNKNOWN;

  for (let t of typeArray) {
    let result = null;
    if (subtype.toLowerCase().indexOf(t) > -1) {
      result = t;
      return result;
    }
  }

  return result;
}
